import { createFlowEndpoints } from './flowEndpoints';
import { createIndexEndpoints } from './indexEndpoints';
import { createSuperTokenEndpoints } from './superTokenEndpoints';
export const allRpcEndpoints = {
    endpoints: (builder) => Object.assign(createFlowEndpoints(builder), createIndexEndpoints(builder), createSuperTokenEndpoints(builder)),
};
//# sourceMappingURL=allRpcEndpoints.js.map